/**
 * Mock API client. Swap with real fetch/axios when wiring backend.
 */

const DEFAULT_LATENCY = 350;

export function simulate<T>(payload: T, latencyMs = DEFAULT_LATENCY): Promise<T> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(payload), latencyMs);
  });
}

export function simulateError(message: string, latencyMs = DEFAULT_LATENCY): Promise<never> {
  return new Promise((_, reject) => {
    setTimeout(() => reject(new Error(message)), latencyMs);
  });
}

export function uid(prefix = 'id'): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}
